// 考核单-待确定
<template>
	<div id="containt">
		<el-tabs v-model="activeName" class="tab-box">
			<el-tab-pane label="常规" name="first">
				<!-- <editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :parent-target="_self"
					@reload="$reloadHandle"></editView> -->
			</el-tab-pane>
			<el-tab-pane label="列表" name="second">
				<div class="grid-height">
					<vxe-grid show-overflow height="115%" :row-config="{ isHover: true }" ref="table-m1" v-bind="vxeOption"
						:checkbox-config="{ labelField: '', highlight: true, reserve: true, range: true }"
						@checkbox-all="selectAllEvent" @checkbox-change="selectChangeEvent"
						@resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle">

						<template #form>
							<div class="clearfix screen-btns">
								<div class="fl">
									<!-- <vxe-button status="primary" class="button-sty" icon="el-icon-plus"
										@click="openEditDialog">新增</vxe-button> -->
									<vxe-button status="primary" class="button-sty" icon="el-icon-plus"
										@click="handleDeleteList">批量确定
									</vxe-button>
								</div>
								<div class="fr">
									<vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text"
										status="primary" plain>重置</vxe-button>
									<vxe-button status="warning" icon="el-icon-search" class="button-sty"
										@click="searchEvent">搜索</vxe-button>
								</div>
							</div>
							<vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="formData"
								@submit="searchEvent" @reset="searchEvent">
								<vxe-form-item title="考核单号:" field="name">
									<template v-slot>
										<el-input v-model="formData.name" size="small" clearable />
									</template>
								</vxe-form-item>
								<vxe-form-item title="网点名称:" field="name">
									<template v-slot>
										<el-input v-model="formData.name" size="small" clearable />
									</template>
								</vxe-form-item>
								<vxe-form-item title="工单号:" field="name">
									<template v-slot>
										<el-input v-model="formData.name" size="small" clearable />
									</template>
								</vxe-form-item>
								<vxe-form-item title="结算单号:" field="name">
									<template v-slot>
										<el-input v-model="formData.name" size="small" clearable />
									</template>
								</vxe-form-item>
								<vxe-form-item title="创建时间:" field="name">
									<template v-slot>
										<el-date-picker v-model="value2" type="daterange" align="right" unlink-panels
											range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
											:picker-options="pickerOptions">
										</el-date-picker>
									</template>
								</vxe-form-item>

								<vxe-form-item title="考核类别:" field="status">
									<template v-slot>
										<el-select v-model="formData.status" clearable>
											<el-option :value="0" label="全部"></el-option>
											<el-option :value="1" label="考核费用"></el-option>
											<el-option :value="2" label="服务态度不好"></el-option>
											<el-option :value="3" label="扣费"></el-option>
										</el-select>
									</template>
								</vxe-form-item>
								<vxe-form-item title="审批时间:" field="name">
									<template v-slot>
										<el-date-picker v-model="value3" type="daterange" align="right" unlink-panels
											range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
											:picker-options="pickerOptions">
										</el-date-picker>
									</template>
								</vxe-form-item>
							</vxe-form>
						</template>
						<template #pager>
							<pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
						</template>
					</vxe-grid>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
// import editView from './edit.vue';
import { tableOption } from '@/const/crud/admin/tenant';
import { initVxeTable } from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
export default {
	inject: ['reload'],
	components: { pager },
	data() {
		return {
			pickerOptions: {
				shortcuts: [{
					text: '最近一周',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近一个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近三个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
						picker.$emit('pick', [start, end]);
					}
				}]
			},
			value2: '',
			value3: '',
			activeName: 'second',
			dataId: 0,
			showEdit: false,
			vxeOption: {},
			// 查询参数
			formData: {
				searchCount: false,  // 是否分页
				orderTypeName: "",  // 来源名称
				current: 1,  // 当前页面
				size: 0,  // 页面数据量
			},
			pageSizes: [10, 20, 100],

			showEdit: false,
		};
	},
	mounted() {
		this.initTableList();
	},
	methods: {
		open() {
			this.$prompt('请填写考核备注', '备注', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				//   inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
				//   inputErrorMessage: '邮箱格式不正确'
			}).then(({ value }) => {
				this.$message({
					type: 'success',
					message: '你的添加的考核备注是: ' + value
				});
				this.reload()// 需要刷新页面
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '取消输入'
				});
				this.reload()// 需要刷新页面
			});
		
		},
		// 下拉框点击事件
		optionChange(value, target) {
			console.log(111, "11111111");
			console.log(value);
			// var select = document.querySelectorAll(".status_select");
			console.log('接受的option的值1', target)
			// var grade = select.options[select.selectedIndex].value;
			// alert(grade);
			// console.log(grade, "grade的值");
			if (target == 2) {
				this.open()
			}

		},
		//全选
		selectAllEvent({ checked, records, reserves }) {
			this.selectionRows = records.map(item => item.id)
			console.log(this.selectionRows)
		},
		//单个选中
		selectChangeEvent(data) {
			if (data.checked) {
				this.selectionRows.push(data.row.id)
			} else {
				this.selectionRows = this.selectionRows.filter(item => item !== data.row.id)
			}
			console.log(this.selectionRows)
		},
		// 分页功能
		changeTablePage(page, flag) {
			console.log('分页数据', page, this.formData)
			this.formData.size = page.pageSize
			this.formData.current = page.currentPage
			this.formData.searchCount = flag
			this.initTableList();
		},
		// 搜索
		searchEvent() {
			this.$refs['table-m1'].commitProxy('reload');

		},
		// 重置
		resetEvent() {
			this.formData = {};
			this.formData.addresswangdian = {};
			this.$refs['table-m1'].commitProxy('reload');
		},
		// 新增
		openEditDialog(id) {
			this.dataId = !id || typeof id == 'object' ? 0 : id;
			this.activeName = 'first';
			// this.$openEditView('showEdit');
		},
		initTableList() {
			let that = this;
			let tableOption = {
				vue: this,
				tableRef: 'table-m1',
				tableName: 'basic_fault_code_list-m1',
				path: '/admin/fwpttenant/listpage',
				param: this.formData,
				method: 'post',
				height: '800px',
				columns: [
					{ type: 'checkbox', width: 60, title: '序号', resizable: false, fixed: 'left' },
					{
						width: 47, fixed: 'right', title: '', sortable: false,
						slots: {
							default: ({ row }) => {
								return [
									<div>
										<a
											href="javascript:void(0);"
											class="a-link"
											onclick={() => {
												this.openEditDialog(row.id);
											}}
										>
											<el-tooltip enterable={false} effect="dark" content="查看" placement="top" popper-class="tooltip-skin">
												<i class="el-icon-edit" />
											</el-tooltip>
										</a>
									</div>
								];
							}
						}
					},
					{
						width: 150,
						field: 'address',
						title: '操作',
						showOverflow: true,
						slots: {
							// 使用 JSX 渲染
							default: ({ row }) => {
								return [
									<div>
										<select class="status_select" v-on:change={($event) => {
											console.log('------------------2', $event.target.value)
											this.optionChange(row, $event.target.value)
										}}  >
											<option>请选择</option>	、
											<option grade="1" value="1">编辑工单</option>
											<option grade="2" value="2">考核备注</option>
											<option grade="3" value="3">确认考核</option>
											<option grade="5" value="5">导出PDf</option>
										</select>
									</div>
								]
							}
						}
					},
					{
						title: '账务组织',
						field: 'name',
						width: 150,
						// fixed: 'left'
					},
					{
						title: '考核单号',
						field: 'parent_id',
						width: 150,
					},
					{
						title: '网点名称',
						field: 'status',
						width: 150,
					},
					{
						title: '状态',
						field: 'shortName',
						width: 150,
						slots: {
							default: ({ row }) => {
								if (row.isShowwx == 1) {
									return [
										<div>
											<span>制单</span>
										</div>
									];
								} else if (row.isShowwx == 2) {
									return [
										<div>
											<span>待确认</span>
										</div>
									];
								} else if (row.isShowwx == 3) {
									return [
										<div>
											<span>待申诉</span>
										</div>
									];
								}
								else if (row.isShowwx == 5) {
									return [
										<div>
											<span>已申诉</span>
										</div>
									];
								}
								else if (row.isShowwx == 7) {
									return [
										<div>
											<span>执行考核</span>
										</div>
									];
								}
								else if (row.isShowwx == 9) {
									return [
										<div>
											<span>已结算</span>
										</div>
									];
								}
								else if (row.isShowwx == 19) {
									return [
										<div>
											<span>取消执行</span>
										</div>
									];
								}
								else if (row.isShowwx == 99) {
									return [
										<div>
											<span>关闭</span>
										</div>
									];
								}
							}
						}
					},
					{
						title: '考核类别',
						field: 'parent_id',
						width: 150,
					},
					{
						title: '费用类别',
						field: 'parent_id',
						width: 150,
					},
					{
						title: '考核金额',
						field: 'parent_id',
						width: 150,
					},
					{
						title: '调整金额',
						field: 'parent_id',
						width: 150,
					},
					{
						title: '合计金额',
						field: 'parent_id',
						width: 150,
					},

					{
						title: '工单号',
						field: 'shortName',
						width: 150,
						slots: {
							default: ({ row }) => {
								if (row.isShowwx == 1) {
									return [
										<div>
											<span>制单</span>
										</div>
									];
								} else if (row.isShowwx == 2) {
									return [
										<div>
											<span>待确认</span>
										</div>
									];
								} else if (row.isShowwx == 3) {
									return [
										<div>
											<span>待申诉</span>
										</div>
									];
								}
								else if (row.isShowwx == 5) {
									return [
										<div>
											<span>已申诉</span>
										</div>
									];
								}
							}
						}
					},


					// {
					// 	title: '是否需要网点申诉',
					// 	field: 'shortName',
					// 	width: 150,
					// 	slots: {
					// 		default: ({ row }) => {
					// 			if (row.isShowwx == 0) {
					// 				return [
					// 					<div>
					// 						<span>否</span>
					// 					</div>
					// 				];
					// 			} else if (row.isShowwx == 1) {
					// 				return [
					// 					<div>
					// 						<span>是</span>
					// 					</div>
					// 				];
					// 			}
					// 		}
					// 	}
					// },
					{
						title: '建单人',
						field: 'parent_id',
						width: 150,
					},
					{
						title: '审批金额',
						field: 'parent_id',
						width: 150,
					},
					{
						title: '审批时间',
						field: 'parent_id',
						width: 150,
					},
					{
						title: '服务类型',
						field: 'parent_id',
						width: 150,
					},
					{
						title: '中心机构',
						field: 'parent_id',
						width: 150,
					},
					{
						title: '机构编码',
						field: 'parent_id',
						width: 150,
					},

				]
			};
			// initVxeTable(tableOption).then(opts => {
			this.vxeOption = initVxeTable(tableOption);
			this.$refs['table-m1'].commitProxy('reload');
		},
	}
};
</script>
<style lang="scss" >
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
	.el-radio__inner {
		border: 0px;
		background: transparent;
	}

	.el-radio__input.is-checked .el-radio__inner {
		background: none;
	}

	.el-radio {
		height: 100%;
		width: 150px;
		position: absolute;
		z-index: 10;
	}
}
</style>